import * as React from "react";
import {RouteComponentProps} from "react-router";

export default class NewVariableSet extends React.Component<RouteComponentProps<void>> {
    render() {
        return <div>
            TODO
        </div>;
    }
}